export default __webpack_public_path__ + "static/media/kitchen3-afterB-480w.cd5d4093.avif";